<div class="no-results">
  <img class="no-results__img" src="assets/search/person-searching.svg" />
  <p class="no-results__text" i18n="@@featureNewsfeed-no-results">
    Aktuell gibt es hier noch keine Inhalte.<br />Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.
  </p>
</div>
